module.exports = __webpack_public_path__ + "static/apple-store-03e97866991ec1e44a4d48d6bf5bd553.png";